import type { ComponentProps } from "react";

export function Settings(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="bevel"
				strokeWidth={1.5}
				d="M19.787 8.989H4.69"
			/>
			<circle
				cx={9.641}
				cy={8.989}
				r={2.25}
				fill="#060607"
				stroke="currentColor"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="bevel"
				strokeWidth={1.5}
				d="M19.787 16.982H4.69"
			/>
			<circle
				cx={14.946}
				cy={16.982}
				r={2.25}
				fill="#060607"
				stroke="currentColor"
				strokeWidth={1.5}
			/>
		</svg>
	);
}
